import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import { isNullOrUndefined } from "util";

export default {
  methods: {
    synchronize: function (conditionWrapper, rewardWrapper) {
      var listBreakPoint = []
      var listRewardValues = []
      var sizeBreakPoint = null
      var sizeRewardValues = null
      listBreakPoint = this.getFirstBreakPoints(conditionWrapper)
      sizeBreakPoint = listBreakPoint ? listBreakPoint.length : 0;
      if (sizeBreakPoint > 0) {
        // Si hay algun brekpoint
        for (let j = 0; j < rewardWrapper.length; j++) {
          if (!isNullOrUndefined(rewardWrapper[j].rewardValuesWrapper)) {
            listRewardValues = rewardWrapper[j].rewardValuesWrapper
            sizeRewardValues = listRewardValues.length
            let diff = sizeRewardValues - sizeBreakPoint
            if (sizeBreakPoint >= sizeRewardValues) {
              let index = - diff
              for (let k = 0; k < index; k++) {
                listRewardValues = listRewardValues.concat({ value: "", breakPoint: null })
              }
              this.checkBreakPoint(listBreakPoint, listRewardValues)
            }
            if (sizeBreakPoint <= sizeRewardValues) {
              for (let l = 0; l < diff; l++) {
                listRewardValues.pop()
              }
              this.checkBreakPoint(listBreakPoint, listRewardValues)
            }
            if (sizeBreakPoint == sizeRewardValues) {
              this.checkBreakPoint(listBreakPoint, listRewardValues)
            }
            rewardWrapper[j].rewardValuesWrapper = listRewardValues
          }
        }
        // Sino limpia los reward values
      } else {
        for (let p = 0; p < rewardWrapper.length; p++) {
          rewardWrapper[p].rewardValuesWrapper = []
        }
      }
      return rewardWrapper;
    },
    getFirstBreakPoints: function (conditionWrapper) {
      var breakPointList = []
      if (conditionWrapper.length > 0) {
        for (let i = 0; i < conditionWrapper.length; i++) {
          if (conditionWrapper[i].condition.rewardGrant == 3) {
            breakPointList = conditionWrapper[i].condition.breakPoints;
            if (breakPointList.length > 0) {
              return breakPointList;
            }
          }
        }
      }
    },
    checkBreakPoint: function (bp, rv) {
      for (let i = 0; i < bp.length; i++) {
        rv[i].breakPoint = bp[i].value
      }
    },
    newRewardBreakPoints: function (conditionWrapper) {
      var listBreakPoint = []
      var rewardValues = []
      var sizeBreakPoint = null
      if (conditionWrapper.length > 0) {
        listBreakPoint = this.getFirstBreakPoints(conditionWrapper)
        sizeBreakPoint = listBreakPoint ? listBreakPoint.length : 0;
        if (sizeBreakPoint > 0) {
          for (let m = 0; m < sizeBreakPoint; m++) {
            rewardValues = rewardValues.concat({ value: "", breakPoint: null })
          }
          this.checkBreakPoint(listBreakPoint, rewardValues)
        } else {
          rewardValues = []
        }
      } else {
        rewardValues = []
      }
      return rewardValues
    },
  },
};